import {Script, System} from '../../index.js';

/**
 * Creates Hypercube.js script systems.
 * @example
 * const systemscript = new SystemScript();
 *
 * // called by an update loop
 * systemscript.tick(timeframe);
 */
class SystemScript extends System {

    /**
     * Creates a new Hypercube.js script system.
     */
    constructor() {

        super();
    }

    /**
     * Destroys the system.
     * @public
     */
    destroy() {

        this.scene.getnodes(this.scene.noderoot).forEach(($current) => {

            const script = $current.script;

            if (!(script instanceof Script)) {

                return;
            }

            if (script.running === false) {

                script.setengine(this.engine);
                script.onstart($current);
            }

            script.ondestroy($current);
        });
    }

    /**
     * Starts the system.
     * @public
     */
    start() {

        this.scene.getnodes(this.scene.noderoot).forEach(($current) => {

            const script = $current.script;

            if (!(script instanceof Script)) {

                return;
            }

            if (script.running === false) {

                script.setengine(this.engine);
                script.onstart($current);
            }
        });
    }

    /**
     * Updates the system once.
     * @param {number} $timeframe The timeframe duration (in ms).
     * @public
     */
    tick($timeframe) {

        this.scene.getnodes(this.scene.noderoot).forEach(($current) => {

            const script = $current.script;

            if (!(script instanceof Script)) {

                return;
            }

            if (script.running === false) {

                script.setengine(this.engine);
                script.onstart($current);
            }

            script.ontick($timeframe, $current);
        });
    }
}

export {

    SystemScript
};

export default SystemScript;
